export default __webpack_public_path__ + "static/media/iIcon.0cc11e0f.svg";